<template>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="11"
      >
        <material-card
          color="primary"
          icon="mdi-account-outline"
          icon-small
        >
          <template #title>
            <!-- Profile — <small class="text-body-1">Complete your profile</small> -->
            프로필
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="user.company"
                    label="회사명"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="user.username"
                    color="primary"
                    label="사용자명"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="user.email"
                    color="primary"
                    label="이메일"
                  />
                </v-col>

                <!-- <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="user.username"
                    color="primary"
                    label="First Name"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="user.username"
                    color="primary"
                    label="Last Name"
                  />
                </v-col> -->

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="user.department"
                    color="primary"
                    label="부서명"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="user.team"
                    color="primary"
                    label="팀명"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="user.position"
                    color="primary"
                    label="직책"
                  />
                </v-col>

                <!-- <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    color="primary"
                    label="City"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    color="primary"
                    label="Country"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    color="primary"
                    label="Postal Code"
                    type="number"
                  />
                </v-col> -->

                <!-- <v-col cols="12">
                  <v-textarea
                    color="primary"
                    label="About Me"
                    value="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                  />
                </v-col> -->

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="primary"
                    large
                    min-width="150"
                    @click="updateProfile"
                  >
                    프로필 수정
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </material-card>
      </v-col>

      <!-- <v-col
        cols="12"
        md="4"
      >
        <app-card class="mt-4 text-center">
          <v-img
            class="rounded-circle elevation-6 mt-n12 d-inline-block"
            src="https://demos.creative-tim.com/vue-material-dashboard/img/marc.aba54d65.jpg"
            width="128"
          />

          <v-card-text class="text-center">
            <h6 class="text-h6 mb-2 text--secondary">
              CEO / FOUNDER
            </h6>

            <h4 class="text-h4 mb-3 text--primary">
              John Leider
            </h4>

            <p class="text--secondary">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione dolorem deserunt veniam tempora magnam quisquam quam error iusto cupiditate ducimus, et eligendi saepe voluptatibus assumenda similique temporibus placeat animi dicta?
            </p>

            <v-btn
              class="mr-0"
              color="primary"
              min-width="100"
              rounded
            >
              Follow
            </v-btn>
          </v-card-text>
        </app-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
  import { sync, get } from 'vuex-pathify'
  import { snackbarOpen } from '@/util/helpers'

  export default {
    name: 'UserProfileView',

    computed: {
      user: sync('user/info'),
      token: get('user/token'),
    },

    methods: {
      async updateProfile () {
        const user = { ...this.user }
        // console.log(user)
        await this.$http.put(`/api/v1/users/${user._id}/profile`, user).then(response => {
          // console.log(response.data)
          this.$cookies.set('user', { ...user, token: this.token }, 0)
          this.$store.set('user/info', user)
          snackbarOpen('success', '프로필이 수정되었습니다.', 'success')
        }).catch(error => {
          console.log(error)
        })
      },
    },
  }
</script>
